import { FC } from "react";

import { FeedbackStatusCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const FeedbackStatusCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
}) => {
  return <FeedbackStatusCell status={value}></FeedbackStatusCell>;
};
